export default "__VITE_ASSET__198aa378__"